import { type RootState } from "features/Application/store/store";
import { RStatus } from "features/Application/types";

// selectors
export const selectUserSettings = (state: RootState) => state.account.userSettings;
export const selectSettingsLoaded = (state: RootState) => state.account.userSettings.status === RStatus.Got;
export const selectPrivacyPolicyViewed = (state: RootState) => state.account.userSettings.settings?.privacyPolicyViewed;
